// All the events

export const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "conde-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  FILE_CREATE: "file-create",
  FILE_DELETE: "file-delete",
  FILE_RENAME: "file-rename",
  FILE_SELECT: "file-select",
  FILE_SYNC: "file-sync",
};
